"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateZipCode = exports.validateWalletType = exports.validateVatNumber = exports.validateUserToken = exports.validateUserGroup = exports.validateUrl = exports.validateUiKey = exports.validateUUID = exports.validateTinyUrl = exports.validateTelegramToken = exports.validateSuspensionReason = exports.validateStringLength = exports.validateStartStopUnix = exports.validateResourceInputItem = exports.validateReferralCode = exports.validateRangeNumber = exports.validatePrefixTags = exports.validatePrefixManuallyMonitorable = exports.validatePrefixInputItem = exports.validatePrefixDescription = exports.validatePort = exports.validatePlainString = exports.validatePayPalTransactionId = exports.validatePagerdutyConfig = exports.validateOrganizationInfo = exports.validateOrderType = exports.validateOption = exports.validateObjectKeys = exports.validateNumber = exports.validateNotificationServiceType = exports.validateNotificationService = exports.validateNoCodeString = exports.validateMonitorName = exports.validateIsoCountryCode = exports.validateIpRange = exports.validateInvoiceRequest = exports.validateIntegrationWebhook = exports.validateIntegrationTeams = exports.validateIntegrationPayload = exports.validateIntegrationOpsgenie = exports.validateIntegrationName = exports.validateIntegrationJira = exports.validateIntegrationConfigTelegram = exports.validateIntegrationConfigSyslog = exports.validateIntegrationConfigEmail = exports.validateIntegration = exports.validateInt = exports.validateInstanceName = exports.validateInstanceId = exports.validateInstanceConfig = exports.validateHost = exports.validateHealthCheckService = exports.validateHealthCheckPeriod = exports.validateHealthCheckGroup = exports.validateHealthCheck = exports.validateGraphPruningTraversedTimes = exports.validateGraphPruningDistance = exports.validateGraphInputHistory = exports.validateGraphExpansions = exports.validateFingerprint = exports.validateEventType = exports.validateEventSeverity = exports.validateEmailTemplate = exports.validateEmailIds = exports.validateEmail = exports.validateDateIsoString = exports.validateCurrencySymbol = exports.validateCurrencyName = exports.validateBooleanField = exports.validateBillParameter = exports.validateBgpFields = exports.validateBgpEventId = exports.validateBgpEventDataType = exports.validateBgpConfiguration = exports.validateAsFromString = exports.validateArray = exports.validateApiKeyName = exports.validateApiKeyExpiration = exports.validateApiKey = exports.validateASnItem = exports.tryCatch = exports.suspensionReasons = exports.rirs = exports.preventDeletionResourcesForSuspensionReasons = exports.prefixTags = exports.eventTypesPerService = exports.eventTypes = exports.euEurostatCountries = exports.errorString = exports.emailTemplates = exports.defaultSeverities = exports.currencies = exports.bool = exports.bgpEventDataType = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _netValidations = require("net-validations");
var _ipSub = _interopRequireDefault(require("ip-sub"));
var _isEmail = _interopRequireDefault(require("validator/lib/isEmail"));
var _isBoolean = _interopRequireDefault(require("validator/lib/isBoolean"));
var _isURL = _interopRequireDefault(require("validator/lib/isURL"));
var _isUUID = _interopRequireDefault(require("validator/lib/isUUID"));
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
var _isHash = _interopRequireDefault(require("validator/lib/isHash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var rirs = exports.rirs = ["RIPE", "ARIN", "AFRINIC", "APNIC", "LACNIC"];
var suspensionReasons = exports.suspensionReasons = ["eventLimit", "admin", "billing", "eventLimitLight", "user"];
var preventDeletionResourcesForSuspensionReasons = exports.preventDeletionResourcesForSuspensionReasons = ["eventLimit", "admin", "eventLimitLight"];
var emailTemplates = exports.emailTemplates = ["invite", "notification", "test", "contact", "invoice", "upgrade", "log", "integration", "deletion", "verification", "unsubscribe"];
var euEurostatCountries = exports.euEurostatCountries = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "EL", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "XI"];
var currencies = exports.currencies = {
  "USD": "$",
  "EUR": "€"
};
var eventTypesPerService = exports.eventTypesPerService = {
  bgp: ["setup", "hijack", "rpki", "roa", "visibility", "misconfiguration", "bogons", "path", "newprefix", "neighbors", "ta-expire", "rpki-invalid", "rpki-disappear", "rpki-unknown", "ta-malfunction", "roa-diff", "roa-expire", "config-update", "prefix-validity", "grouped", "instability-path", "obfuscated"],
  generic: ["test", "status", "admin", "log"],
  healthcheck: ["online", "offline"]
};
var defaultSeverities = exports.defaultSeverities = {
  admin: {
    value: 3,
    editable: false
  },
  grouped: {
    value: 4,
    editable: false
  },
  log: {
    value: 1,
    editable: false
  },
  test: {
    value: 4,
    editable: false
  },
  setup: {
    value: 2,
    editable: false
  },
  "config-update": {
    value: 1,
    editable: false
  },
  hijack: {
    value: 4,
    editable: true
  },
  visibility: {
    value: 3,
    editable: true
  },
  path: {
    value: 2,
    editable: true
  },
  misconfiguration: {
    value: 2,
    editable: true
  },
  "rpki-invalid": {
    value: 4,
    editable: true
  },
  "rpki-disappear": {
    value: 3,
    editable: true
  },
  "rpki-unknown": {
    value: 1,
    editable: true
  },
  "ta-expire": {
    value: 1,
    editable: true
  },
  "ta-malfunction": {
    value: 1,
    editable: true
  },
  "roa-diff": {
    value: 2,
    editable: true
  },
  "roa-expire": {
    value: 4,
    editable: true
  },
  newprefix: {
    value: 2,
    editable: true
  },
  neighbors: {
    value: 3,
    editable: true
  },
  bogons: {
    value: 4,
    editable: true
  },
  online: {
    value: 2,
    editable: false
  },
  offline: {
    value: 4,
    editable: false
  }
};
var eventTypes = exports.eventTypes = Object.values(eventTypesPerService).flat();
var bgpEventDataType = exports.bgpEventDataType = ["history", "layout", "roas", "resolution", "comment", "pulse"];
var prefixTags = exports.prefixTags = ["other-origin"];
var validateCurrencySymbol = exports.validateCurrencySymbol = function validateCurrencySymbol(symbol) {
  if (!Object.values(currencies).includes(symbol)) {
    throw new Error("Invalid currency symbol");
  }
};
var validateCurrencyName = exports.validateCurrencyName = function validateCurrencyName(name) {
  if (!currencies[name]) {
    throw new Error("Invalid currency name");
  }
};
var validatePlainString = exports.validatePlainString = function validatePlainString(str, length, fieldName) {
  var min = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var reg = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "^[A-Za-z0-9\-]*$";
  var regex = new RegExp(reg);
  if (typeof str !== "string" || !regex.test(str)) {
    throw new Error("Not valid ".concat(fieldName));
  }
  validateStringLength(str, length, min);
};
var validateApiKeyName = exports.validateApiKeyName = function validateApiKeyName(name) {
  validatePlainString(name, 32, "API key name", 0);
  if (name.length < 3) {
    throw new Error("API key name too short");
  }
};
var validateUUID = exports.validateUUID = function validateUUID(value) {
  try {
    if (!(0, _isUUID["default"])(value)) {
      throw new Error();
    }
  } catch (e) {
    // Catch not valid and isUUID thrown errors
    throw new Error("Not a valid UUID");
  }
};
var validateUiKey = exports.validateUiKey = function validateUiKey(value) {
  if (!(0, _isHash["default"])(value, "md5")) {
    throw new Error("Not a valid key");
  }
};
var validateBgpEventId = exports.validateBgpEventId = function validateBgpEventId(id) {
  var validateOldEventId = function validateOldEventId(id) {
    var _id$slice, _id$slice2;
    var md5 = (_id$slice = id.slice(0, 32)) !== null && _id$slice !== void 0 ? _id$slice : "";
    var uuid4 = (_id$slice2 = id.slice(33)) !== null && _id$slice2 !== void 0 ? _id$slice2 : "";
    if (!(0, _isHash["default"])(md5, "md5") || !(0, _isUUID["default"])(uuid4, 4)) {
      throw new Error("Not a valid event id");
    }
  };
  var validateNewEventId = function validateNewEventId(id) {
    if (!(0, _isHash["default"])(id, "md5")) {
      throw new Error("Not a valid event id");
    }
  };
  try {
    validateNewEventId(id);
  } catch (error) {
    validateOldEventId(id);
  }
};
var validateInt = exports.validateInt = function validateInt(value) {
  if (value == null || !(0, _isInt["default"])(value === null || value === void 0 ? void 0 : value.toString())) {
    throw new Error("Not a valid integer");
  }
};
var validateUrl = exports.validateUrl = function validateUrl(value) {
  if (!value || !(0, _isURL["default"])(value, {
    allow_protocol_relative_urls: false
  })) {
    throw new Error("Not a valid URL");
  }
};
var validateEmail = exports.validateEmail = function validateEmail(value) {
  if (!(0, _isEmail["default"])(value)) {
    throw new Error("Not valid email");
  }
};
var validateAsFromString = exports.validateAsFromString = function validateAsFromString(value) {
  try {
    var asn = parseInt(value);
    if (asn != value) {
      throw new Error();
    }
    (0, _netValidations.validateAS)(asn);
  } catch (e) {
    throw new Error("Not valid AS number");
  }
};
var validateOption = exports.validateOption = function validateOption(item, options, name) {
  if (!options.includes(item)) {
    throw new Error("The ".concat(name, " is not valid"));
  }
};
var validateUserToken = exports.validateUserToken = function validateUserToken(str) {
  var regex = new RegExp("^[A-Za-z0-9\-]*$");
  if (!str || str.length !== 36 || !regex.test(str)) {
    throw new Error("Not valid user token");
  }
};
var validateInstanceId = exports.validateInstanceId = function validateInstanceId(instanceId) {
  if (!instanceId || !(0, _isInt["default"])(instanceId.toString())) {
    throw new Error("Not valid instance ID");
  }
};
var validateEmailIds = exports.validateEmailIds = function validateEmailIds(emailIds) {
  validateArray(emailIds, validateInt, "email", false);
};
var validateInstanceName = exports.validateInstanceName = function validateInstanceName(str) {
  var regex = new RegExp("^[A-Za-z0-9\-\_ \.]*$");
  if (!str || str.length < 1 || str.length > 60 || !regex.test(str)) {
    throw new Error("Not valid instance name");
  }
};
var validateUserGroup = exports.validateUserGroup = function validateUserGroup(str) {
  var regex = new RegExp("^g-[0-9]+$");
  if (!str || str.length < 3 || !regex.test(str)) {
    throw new Error("Not valid user group name");
  }
};
var bool = exports.bool = function bool(func, str) {
  try {
    var result = func(str);
    return typeof result === "boolean" ? result : true;
  } catch (e) {
    return false;
  }
};
var errorString = exports.errorString = function errorString(func, str) {
  try {
    func(str);
    return null;
  } catch (e) {
    return e.message;
  }
};
var tryCatch = exports.tryCatch = function tryCatch(func, str, error) {
  var result = bool(func, str);
  if (!result) {
    throw new Error(error);
  }
};
var validateNotificationService = exports.validateNotificationService = function validateNotificationService(service) {
  if (!["bgp", "generic", "healthcheck"].includes(service)) {
    throw new Error("Invalid service type");
  }
};
var validateNotificationServiceType = exports.validateNotificationServiceType = function validateNotificationServiceType(service, type) {
  var types = eventTypesPerService[service];
  if (!types || !types.includes(type)) {
    throw new Error("Invalid notification type");
  }
};
var validateEventSeverity = exports.validateEventSeverity = function validateEventSeverity(value) {
  if (!Number.isInteger(value) || value < 1 || value > 4) {
    throw new Error("The severity value is not valid: " + value);
  }
};
var validateApiKey = exports.validateApiKey = function validateApiKey(key) {
  if (!key || typeof key !== "string" || key.length !== 64) {
    throw new Error("Invalid API key format");
  }
};
var validateEventType = exports.validateEventType = function validateEventType(name) {
  var events = Object.values(eventTypesPerService).flat();
  if (!events.includes(name)) {
    throw new Error("Not valid event type");
  }
};
var validateGraphExpansions = exports.validateGraphExpansions = function validateGraphExpansions(graph, expansions) {
  if (!Array.isArray(expansions) || expansions.some(function (id) {
    return !Number.isInteger(id);
  })) {
    throw new Error("The expansions must be an array of Integers");
  }
  if (expansions.length) {
    var clusterIds = graph.clusters.map(function (i) {
      return i.id;
    });
    if (expansions.some(function (id) {
      return !clusterIds.includes(id);
    })) {
      throw new Error("The requested expansion it's not possible");
    }
  }
};
var validateStringLength = exports.validateStringLength = function validateStringLength(str) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 255;
  var min = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (str.length > max) {
    throw new Error("String too long");
  }
  if (str.length < min) {
    throw new Error("String too short");
  }
};
var validateGraphInputHistory = exports.validateGraphInputHistory = function validateGraphInputHistory(history) {
  var keys = ["targets", "sources", "nodes", "clusters", "initialState", "events", "query_starttime", "query_endtime"];
  var start = history["query_starttime"];
  var stop = history["query_endtime"];
  validateStartStopUnix(start, stop);
  if (Object.keys(history).some(function (key) {
    return !keys.includes(key);
  })) {
    throw new Error("Invalid history json");
  }
  if ([].concat(_toConsumableArray(history.targets), _toConsumableArray(history.sources), _toConsumableArray(history.nodes), _toConsumableArray(history.clusters)).some(function (i) {
    return i.id == null;
  })) {
    throw new Error("Invalid history json: all objects must have an id");
  }
  var nodesIndex = {};
  var sourcesIndex = {};
  var targetsIndex = {};
  var clustersIndex = {};
  var _iterator = _createForOfIteratorHelper(history.nodes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;
      nodesIndex[node.id] = node;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(history.sources),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var source = _step2.value;
      sourcesIndex[source.id] = source;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var _iterator3 = _createForOfIteratorHelper(history.targets),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var target = _step3.value;
      targetsIndex[target.id] = target;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  var _iterator4 = _createForOfIteratorHelper(history.clusters),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var cluster = _step4.value;
      clustersIndex[cluster.id] = cluster;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  var validateEvent = function validateEvent(_ref) {
    var source_id = _ref.source_id,
      target_id = _ref.target_id,
      path = _ref.path,
      timestamp = _ref.timestamp;
    if (timestamp && (timestamp < start || timestamp > stop)) {
      throw new Error("An event is outside of the requested time range ".concat(timestamp));
    }
    if (!sourcesIndex[source_id]) {
      throw new Error("source id not available");
    }
    if (!targetsIndex[target_id]) {
      throw new Error("source id not available");
    }
    if (!Array.isArray(path) || path.some(function (id) {
      return !nodesIndex[id];
    })) {
      throw new Error("path not valid");
    }
  };
  history.initialState.map(validateEvent);
  if (history.events.some(function (i) {
    return i.attrs == null || i.timestamp == null || i.type == null;
  }) || history.events.map(function (i) {
    return i.attrs;
  }).some(validateEvent)) {
    throw new Error("Invalid history json: events is not correct");
  }
};
var validateDateIsoString = exports.validateDateIsoString = function validateDateIsoString(str) {
  var ISO_8601 = _moment["default"].HTML5_FMT.DATETIME_LOCAL_MS + "Z";
  if (!(0, _moment["default"])(str, ISO_8601, true).isValid()) {
    throw new Error("Not a valid iso string date");
  }
};
var validateStartStopUnix = exports.validateStartStopUnix = function validateStartStopUnix(start, stop, maxWindow) {
  var tolerance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (!Number.isInteger(start) || !Number.isInteger(stop) || stop < start) {
    throw new Error("Not valid start stop times.");
  }
  if (maxWindow && stop - start > maxWindow + tolerance) {
    throw new Error("Time window too large (".concat(stop, ", ").concat(start, "): max ").concat(maxWindow, " seconds allowed"));
  }
};
var validateGraphPruningDistance = exports.validateGraphPruningDistance = function validateGraphPruningDistance(distance) {
  if (!Number.isInteger(distance) || distance < 1 || distance > 256) {
    throw new Error("The distance must be an integer >= 1 and < 256");
  }
};
var validateGraphPruningTraversedTimes = exports.validateGraphPruningTraversedTimes = function validateGraphPruningTraversedTimes(times) {
  if (!Number.isInteger(times) || times <= 1 || times > 800) {
    throw new Error("The traversed time count must be an integer > 1 and < 256");
  }
};
var validateBgpFields = exports.validateBgpFields = function validateBgpFields(fields) {
  var bgpFields = ["prefix", "originAS", "timestamp", "path", "communities", "nextHop", "sourceProtocol", "localPref", "med", "peer", "type", "seq"];
  if (fields) {
    var _iterator5 = _createForOfIteratorHelper(fields),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var field = _step5.value;
        if (!bgpFields.includes(field)) {
          throw new Error("The requested BGP field is not valid");
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }
};
var validateBgpEventDataType = exports.validateBgpEventDataType = function validateBgpEventDataType(type) {
  if (!bgpEventDataType.includes(type)) {
    throw new Error("BGP event dataType not valid");
  }
};
var validateBooleanField = exports.validateBooleanField = function validateBooleanField(value, name) {
  if (value == null || !(0, _isBoolean["default"])(value.toString())) {
    throw new Error("".concat(name, " must be boolean"));
  }
};
var validateMonitorName = exports.validateMonitorName = function validateMonitorName(name) {
  var monitors = ["monitorHijack", "monitorPath", "monitorVisibility", "monitorAS", "monitorRPKI", "monitorROAS", "monitorPathNeighbors"];
  if (!monitors.includes(name)) {
    throw new Error("The monitor does not exist");
  }
};
var validatePrefixManuallyMonitorable = exports.validatePrefixManuallyMonitorable = function validatePrefixManuallyMonitorable(prefix) {
  (0, _netValidations.validatePrefix)(prefix);
  var af = _ipSub["default"].getAddressFamily(prefix);
  var _ipUtils$getIpAndCidr = _ipSub["default"].getIpAndCidr(prefix),
    _ipUtils$getIpAndCidr2 = _slicedToArray(_ipUtils$getIpAndCidr, 2),
    _ = _ipUtils$getIpAndCidr2[0],
    cidr = _ipUtils$getIpAndCidr2[1];
  if (af === 4 && cidr < 12 || af === 6 && cidr < 16) {
    throw new Error("CIDR too small");
  }
  var privateSpace = ["127.0.0.0/8", "10.0.0.0/8", "172.16.0.0/12", "192.168.0.0/16", "198.51.100.0/24", "203.0.113.0/24", "fc00::/7", "fe80::/64", "2001:db8::/32"];
  if (privateSpace.some(function (p) {
    return _ipSub["default"].isEqualPrefix(p, prefix) || _ipSub["default"].isSubnet(p, prefix);
  })) {
    throw new Error("You cannot monitor this prefix");
  }
};
var validatePrefixDescription = exports.validatePrefixDescription = function validatePrefixDescription(description) {
  if (typeof description !== "string" || description.length > 200) {
    throw new Error("Not valid description");
  }
  if (!description || description.trim().length === 0) {
    throw new Error("Type a description for the prefix. Something that makes you understand what service runs on it.");
  }
};
var validateResourceInputItem = exports.validateResourceInputItem = function validateResourceInputItem(resource) {
  if (resource.type === "prefix") {
    return validatePrefixInputItem(resource);
  } else if (resource.type === "asn") {
    return validateASnItem(resource);
  } else {
    throw new Error("Invalid resource type");
  }
};
var validatePrefixInputItem = exports.validatePrefixInputItem = function validatePrefixInputItem(resource) {
  var prefix = resource.prefix,
    type = resource.type,
    instance = resource.instance,
    description = resource.description,
    asn = resource.asn,
    ignoreMorespecifics = resource.ignoreMorespecifics,
    ignore = resource.ignore,
    excludeMonitors = resource.excludeMonitors,
    includeMonitors = resource.includeMonitors,
    group = resource.group,
    v4 = resource.v4,
    manual = resource.manual,
    active = resource.active,
    tags = resource.tags;
  validateObjectKeys(resource, ["prefix", "type", "instance", "description", "asn", "ignoreMorespecifics", "ignore", "excludeMonitors", "includeMonitors", "group", "v4", "manual", "active", "tags", "lastActiveStatusChange", "suspensionReasons"]);
  if (type !== "prefix") {
    throw new Error("Invalid type for a prefix");
  }
  (0, _netValidations.validatePrefix)(prefix);
  validateInstanceId(instance);
  if (v4) {
    validateBooleanField(v4, "v4");
    if (_ipSub["default"].getAddressFamily(prefix) === 4 !== v4) {
      throw new Error("The address family is not correct");
    }
  }
  validateArray(asn, _netValidations.validateAS, "asn", false);
  if (description) {
    validatePrefixDescription(description);
  }
  if (tags) {
    validatePrefixTags(tags);
  }
  if (group) {
    validateUserGroup(group);
  }
  validateBooleanField(manual, "manual");
  validateBooleanField(active, "active");
  validateBooleanField(ignore, "ignore");
  validateBooleanField(ignoreMorespecifics, "ignoreMorespecifics");
  validateArray(excludeMonitors, validateEventType, "excludeMonitors", true);
  validateArray(includeMonitors, validateEventType, "includeMonitors", true);
};
var validateASnItem = exports.validateASnItem = function validateASnItem(resource) {
  var asn = resource.asn,
    group = resource.group,
    downstreams = resource.downstreams,
    upstreams = resource.upstreams,
    active = resource.active,
    instance = resource.instance,
    type = resource.type,
    excludeMonitors = resource.excludeMonitors,
    includeMonitors = resource.includeMonitors,
    monitorDownstreams = resource.monitorDownstreams,
    monitorUpstreams = resource.monitorUpstreams;
  validateObjectKeys(resource, ["asn", "type", "group", "downstreams", "upstreams", "active", "instance", "excludeMonitors", "includeMonitors", "monitorDownstreams", "monitorUpstreams", "lastActiveStatusChange", "suspensionReasons"]);
  if (type !== "asn") {
    throw new Error("Invalid type for an asn");
  }
  (0, _netValidations.validateAS)(asn);
  validateInstanceId(instance);
  if (group) {
    validateUserGroup(group);
  }
  validateArray(downstreams, _netValidations.validateAS, "downstreams", true);
  validateArray(upstreams, _netValidations.validateAS, "upstreams", true);
  validateBooleanField(active, "active");
  validateBooleanField(monitorDownstreams, "monitorDownstreams");
  validateBooleanField(monitorUpstreams, "monitorUpstreams");
  validateArray(excludeMonitors, validateEventType, "excludeMonitors", true);
  validateArray(includeMonitors, validateEventType, "includeMonitors", true);
};
var validateBgpConfiguration = exports.validateBgpConfiguration = function validateBgpConfiguration(configuration) {
  configuration = JSON.parse(JSON.stringify(configuration));
  if (!configuration.options) {
    throw new Error("The options param is missing");
  }
  var monitorASns = configuration.options.monitorASns;
  delete configuration.options;
  var prefixes = configuration;
  Object.keys(prefixes).forEach(function (prefix) {
    return validatePrefixInputItem(prefix, prefixes[prefix]);
  });
  Object.keys(monitorASns).forEach(function (asn) {
    return validateASnItem(parseInt(asn), monitorASns[asn]);
  });
};
var validateTinyUrl = exports.validateTinyUrl = function validateTinyUrl(id, hash) {
  if (!id || !hash || !(0, _isInt["default"])(id.toString()) || hash.length !== 6 || typeof hash !== "string") {
    throw new Error("The url is not valid");
  }
};
var validateIntegration = exports.validateIntegration = function validateIntegration(body) {
  var validKeys = ["instance", "name", "active", "alertTypes", "minSeverity", "config", "createdAt", "errored", "errors"];
  if (Object.keys(body).some(function (key) {
    return !validKeys.includes(key);
  })) {
    throw new Error("Integration configuration has invalid keys");
  }
  validateInstanceId(body.instance);
  validateBooleanField(body.active, "active");
  if (body.active) {
    body.alertTypes.forEach(validateEventType);
    validateEventSeverity(body.minSeverity);
    validateIntegrationPayload(body);
  }
};
var validateIntegrationConfigEmail = exports.validateIntegrationConfigEmail = function validateIntegrationConfigEmail(params) {
  var email = params.email;
  if (!email || Object.keys(params).length !== 1 || !(0, _isEmail["default"])(email)) {
    throw new Error("The email integration config is not valid");
  }
};
var validateIntegrationConfigTelegram = exports.validateIntegrationConfigTelegram = function validateIntegrationConfigTelegram(params) {
  var token = params.token,
    chatId = params.chatId;
  if (!token || !chatId || Object.keys(params).length > 2 || !(0, _isInt["default"])(chatId)) {
    throw new Error("The telegram integration config is not valid");
  }
  validateTelegramToken(token);
};
var validateTelegramToken = exports.validateTelegramToken = function validateTelegramToken(token) {
  if (!new RegExp("[0-9]{9}:[a-zA-Z0-9_-]{35}").test(token)) {
    throw new Error("The telegram token is not valid");
  }
};
var validateHost = exports.validateHost = function validateHost(host) {
  if (!_ipSub["default"].isValidIP(host) && !(0, _isURL["default"])(host, {
    allow_protocol_relative_urls: false
  })) {
    throw new Error("Not a valid host");
  }
};
var validateIntegrationConfigSyslog = exports.validateIntegrationConfigSyslog = function validateIntegrationConfigSyslog(params) {
  var host = params.host,
    port = params.port,
    protocol = params.protocol;
  validateHost(host);
  validatePort(port);
  if (!host || !protocol || Object.keys(params).length > 3 || !["UDP", "TCP"].includes(protocol)) {
    throw new Error("The syslog integration config is not valid");
  }
};
var validatePort = exports.validatePort = function validatePort(port) {
  if (!port || !(0, _isInt["default"])(port.toString()) || parseInt(port) < 1 || parseInt(port) > 65535) {
    throw new Error("The port is not valid");
  }
};
var validateIntegrationWebhook = exports.validateIntegrationWebhook = function validateIntegrationWebhook(params) {
  var webhook = params.webhook;
  if (!webhook || Object.keys(params).length !== 1 || !(0, _isURL["default"])(webhook, {
    allow_protocol_relative_urls: false
  })) {
    throw new Error("The webhook integration config is not valid");
  }
};
var validateIntegrationOpsgenie = exports.validateIntegrationOpsgenie = function validateIntegrationOpsgenie(params) {
  var webhook = params.webhook,
    key = params.key;
  if (!webhook || !key || Object.keys(params).length !== 2 || !(0, _isURL["default"])(webhook, {
    allow_protocol_relative_urls: false
  })) {
    throw new Error("The webhook integration config is not valid");
  }
  validateStringLength(key);
};
var validateIntegrationTeams = exports.validateIntegrationTeams = function validateIntegrationTeams(params) {
  var url = params.url;
  if (!url || Object.keys(params).length !== 1 || !(0, _isURL["default"])(url, {
    allow_protocol_relative_urls: false
  })) {
    throw new Error("The teams integration config is not valid");
  }
};
var validatePagerdutyConfig = exports.validatePagerdutyConfig = function validatePagerdutyConfig(params) {
  var userEmail = params.userEmail,
    serviceId = params.serviceId,
    token = params.token;
  if (!userEmail || !(0, _isEmail["default"])(userEmail)) {
    throw new Error("The email for the pagerduty integration is not valid");
  }
  if (!token || !serviceId || Object.keys(params).length !== 3 || typeof token !== "string" || typeof serviceId !== "string") {
    throw new Error("The pagerduty integration config is not valid");
  }
};
var validateIntegrationJira = exports.validateIntegrationJira = function validateIntegrationJira(params) {
  var apiUrl = params.apiUrl,
    projectId = params.projectId,
    issueTypeId = params.issueTypeId,
    token = params.token,
    userEmail = params.userEmail;
  if (!userEmail || !(0, _isEmail["default"])(userEmail)) {
    throw new Error("The email for the Jira integration is not valid");
  }
  if (!apiUrl || !projectId || !issueTypeId || !token || Object.keys(params).length !== 5 || !(0, _isURL["default"])(apiUrl, {
    allow_protocol_relative_urls: false
  })) {
    throw new Error("The Jira integration config is not valid");
  }
};
var validateIntegrationName = exports.validateIntegrationName = function validateIntegrationName(name) {
  if (!["telegram", "syslog", "email", "sms", "slack", "teams", "mattermost", "webex", "pushover", "rocketchat", "pagerduty", "opsgenie", "jira", "personal"].includes(name)) {
    throw new Error("Invalid integration name");
  }
};
var validateIntegrationPayload = exports.validateIntegrationPayload = function validateIntegrationPayload(_ref2) {
  var name = _ref2.name,
    config = _ref2.config;
  switch (name) {
    case "telegram":
      validateIntegrationConfigTelegram(config);
      break;
    case "syslog":
      validateIntegrationConfigSyslog(config);
      break;
    case "email":
      validateIntegrationConfigEmail(config);
      break;
    case "personal":
      validateIntegrationConfigEmail(config);
      break;
    case "sms":
    // validatePhoneNumber(config?.number);

    // if (Object.keys(config).length !== 1) {
    //     throw new Error("Not valid phone integration")
    // }
    // break;
    case "slack":
      validateIntegrationWebhook(config);
      break;
    case "teams":
      validateIntegrationTeams(config);
      break;
    case "mattermost":
      validateIntegrationWebhook(config);
      break;
    case "webex":
      validateIntegrationWebhook(config);
      break;
    case "pushover":
      if (!config.token || !config.userKey || typeof config.token !== "string" || typeof config.userKey !== "string") {
        throw new Error("The pushover integration configuration is not valid");
      }
      validateStringLength(config.userKey, 30);
      validateStringLength(config.token, 30);
      break;
    case "rocketchat":
      validateIntegrationWebhook(config);
      break;
    case "pagerduty":
      validatePagerdutyConfig(config);
      break;
    case "opsgenie":
      validateIntegrationOpsgenie(config);
      break;
    case "jira":
      validateIntegrationJira(config);
      break;
    default:
      throw new Error("Invalid integration name");
  }
};
var validateInstanceConfig = exports.validateInstanceConfig = function validateInstanceConfig(_ref3) {
  var instanceId = _ref3.instanceId,
    name = _ref3.name,
    _ref3$value = _ref3.value,
    value = _ref3$value === void 0 ? null : _ref3$value;
  var regex = new RegExp("^[A-Za-z0-9\-]*$");
  validateInstanceId(instanceId);
  validatePlainString(name, 120, "name");
  validatePlainString(value === null || value === void 0 ? void 0 : value.toString(), 120, "value");
  if (name.length < 3) {
    throw new Error("name too short");
  }
  if (!name || value === null) {
    throw new Error("The configuration is not valid");
  }
};
var validateIpRange = exports.validateIpRange = function validateIpRange(range) {
  if (!Array.isArray(range) || range.length !== 2) {
    throw new Error("Not a valid IP range");
  }
  range.map(_netValidations.validateIP);
};
var validatePayPalTransactionId = exports.validatePayPalTransactionId = function validatePayPalTransactionId(transactionId) {
  if (!transactionId || transactionId.length > 17 || !/^[A-Za-z0-9]+$/.test(transactionId)) {
    throw new Error("Transaction id is not valid");
  }
};
var validateArray = exports.validateArray = function validateArray(list, method, name) {
  var allowEmpty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!Array.isArray(list)) {
    throw new Error("".concat(name, " must be an array"));
  }
  list.forEach(method);
  if (!allowEmpty && list.length === 0) {
    throw new Error("".concat(name, " cannot be empty"));
  }
};
var validateBillParameter = exports.validateBillParameter = function validateBillParameter(params) {
  if (params !== null) {
    // null is a valid bill params
    if (_typeof(params) === "object") {
      var keys = Object.keys(params);
      if (keys.length > 10) {
        throw new Error("Invalid params payload");
      } else {
        var _iterator6 = _createForOfIteratorHelper(keys),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var key = _step6.value;
            validatePlainString(key, 20, "params");
            var value = params[key];
            if (value !== null && typeof value !== "number") {
              validatePlainString(value === null || value === void 0 ? void 0 : value.toString(), 20, "params", 1, "^[A-Za-z0-9\-\.\/\:]*$");
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    } else {
      // logging the input is a bit dangerous, but setting params
      // is an admin action, and we need logs for better debugging
      throw new Error("Invalid params payload: ".concat(JSON.stringify(params)));
    }
  }
};
var validateReferralCode = exports.validateReferralCode = function validateReferralCode(code) {
  var regex = new RegExp("^[A-Z0-9]{4}-[A-Z0-9]{4}");
  if (!(typeof code === "string" && regex.test(code))) {
    throw new Error("Referral code not valid");
  }
};
var validateObjectKeys = exports.validateObjectKeys = function validateObjectKeys(object, keys) {
  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    if (!keys.includes(key)) {
      validatePlainString(key, 255, "key");
      throw new Error("Invalid property ".concat(key));
    }
  }
};
var validatePrefixTags = exports.validatePrefixTags = function validatePrefixTags(tags) {
  var validateTag = function validateTag(tag) {
    if (!prefixTags.includes(tag)) {
      throw new Error("Not valid prefix tag");
    }
  };
  validateArray(tags, validateTag, "tags", true);
};
var validateFingerprint = exports.validateFingerprint = function validateFingerprint(hash) {
  var isSha = (0, _isHash["default"])(hash, "sha1");
  var isCrc = (0, _isHash["default"])(hash, "crc32") || (0, _isHash["default"])(hash, "crc32b");
  if (!isCrc && !isSha) {
    throw new Error("Invalid fingerprint");
  }
};
var validateZipCode = exports.validateZipCode = function validateZipCode(zipCode) {
  validatePlainString(zipCode === null || zipCode === void 0 ? void 0 : zipCode.toString(), 32, "zipCode", 1, "^[A-Za-z0-9\- ]*$");
};
var validateOrganizationInfo = exports.validateOrganizationInfo = function validateOrganizationInfo(payload, strict) {
  validateObjectKeys(payload, ["name", "vat", "country", "city", "zipCode", "address", "instanceId"]);
  var instanceId = payload.instanceId,
    _payload$name = payload.name,
    name = _payload$name === void 0 ? null : _payload$name,
    _payload$vat = payload.vat,
    vat = _payload$vat === void 0 ? null : _payload$vat,
    _payload$country = payload.country,
    country = _payload$country === void 0 ? null : _payload$country,
    _payload$city = payload.city,
    city = _payload$city === void 0 ? null : _payload$city,
    _payload$zipCode = payload.zipCode,
    zipCode = _payload$zipCode === void 0 ? null : _payload$zipCode,
    _payload$address = payload.address,
    address = _payload$address === void 0 ? null : _payload$address;
  validateInstanceId(instanceId);
  if (strict || city) {
    validateNoCodeString(city, 32, "city", 2);
  }
  if (strict || country) {
    validateIsoCountryCode(country);
  }
  if (strict || address) {
    validateNoCodeString(address, 128, "address", 2);
  }
  if (name) {
    validateNoCodeString(name, 128, "name", 1);
  }
  if (vat) {
    validateVatNumber(vat);
  }
  if (zipCode) {
    validateZipCode(zipCode);
  }
};
var validateVatNumber = exports.validateVatNumber = function validateVatNumber(vat) {
  validatePlainString(vat === null || vat === void 0 ? void 0 : vat.toString(), 32, "vat");
};
var validateNumber = exports.validateNumber = function validateNumber(number) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  if (typeof number !== "number") {
    throw new Error("The attribute ".concat(name, " is not a valid number"));
  }
};
var validateInvoiceRequest = exports.validateInvoiceRequest = function validateInvoiceRequest(bills) {
  var validateBill = function validateBill(_ref4) {
    var paymentExpired = _ref4.paymentExpired,
      paid = _ref4.paid,
      active = _ref4.active,
      instance = _ref4.instance,
      currency = _ref4.currency,
      vatPercentage = _ref4.vatPercentage,
      price = _ref4.price;
    validateNumber(price, "price");
    validateInstanceId(instance);
    validateCurrencyName(currency);
    validateBooleanField(active, "active");
    validateBooleanField(paymentExpired, "paymentExpired");
    validateBooleanField(paid, "paid");
    if (vatPercentage) {
      validateNumber(vatPercentage, "vat");
    }
    if (!(paid || !paymentExpired && active)) {
      throw new Error("We cannot generate an invoice for this bill");
    }
  };
  validateArray(bills, validateBill, "bills", false);
  if (_toConsumableArray(new Set(bills.map(function (i) {
    return i.currency;
  }))).length > 1) {
    throw new Error("You cannot create an invoice with mixed currencies");
  }
  if (_toConsumableArray(new Set(bills.map(function (i) {
    return i.price;
  }))).filter(function (i) {
    return !!i;
  }).length === 0) {
    throw new Error("You cannot create an invoice for free items");
  }
  if (_toConsumableArray(new Set(bills.map(function (i) {
    return i.instance;
  }))).length > 1) {
    throw new Error("You cannot create an invoice for multiple organizations");
  }
  if (_toConsumableArray(new Set(bills.map(function (i) {
    return i.vatPercentage;
  }))).length > 1) {
    throw new Error("You cannot create an invoice for mixed vat percentages");
  }
};
var validateNoCodeString = exports.validateNoCodeString = function validateNoCodeString(string, length, name, min) {
  var excludes = ["->", "<-", "{", "}", ";", "&&", "*", "||", "[", "]", "console.", "=", "eval(", "alert(", "document.", "javascript:", ">>", "<<", "::"];
  if (excludes.some(function (i) {
    return string.includes(i);
  })) {
    throw new Error("Invalid string for ".concat(name));
  }
  validateStringLength(string, length, min);
};
var validateRangeNumber = exports.validateRangeNumber = function validateRangeNumber(numeric) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var min = arguments.length > 2 ? arguments[2] : undefined;
  var max = arguments.length > 3 ? arguments[3] : undefined;
  var number = parseInt(numeric);
  if (numeric === "" || typeof number !== "number" || number < min || number > max) {
    throw new Error("The ".concat(name, " must be a number between ").concat(min, " and ").concat(max));
  }
};
var validateHealthCheckPeriod = exports.validateHealthCheckPeriod = function validateHealthCheckPeriod(period) {
  var min = 10;
  var max = 3600 * 24;
  validateRangeNumber(period, "period", min, max);
};
var validateHealthCheckService = exports.validateHealthCheckService = function validateHealthCheckService(service) {
  validatePlainString(service, 64, "service", 3);
};
var validateHealthCheckGroup = exports.validateHealthCheckGroup = function validateHealthCheckGroup(group) {
  validatePlainString(group, 64, "group", 3);
};
var validateHealthCheck = exports.validateHealthCheck = function validateHealthCheck(_ref5) {
  var instance = _ref5.instance,
    process = _ref5.process,
    service = _ref5.service,
    group = _ref5.group,
    active = _ref5.active,
    period = _ref5.period,
    deleted = _ref5.deleted,
    description = _ref5.description;
  validateInstanceId(instance);
  validateHealthCheckService(service);
  validateHealthCheckGroup(group);
  validateNoCodeString(description, 128, "description", 0);
  if (active != null) {
    validateBooleanField(active);
  }
  if (!!period) {
    validateHealthCheckPeriod(period);
  }
  if (process) {
    validateUUID(process);
  }
  if (deleted != null) {
    validateBooleanField(active);
  }
};
var validateSuspensionReason = exports.validateSuspensionReason = function validateSuspensionReason(reason) {
  if (!suspensionReasons.includes(reason)) {
    throw new Error("Not a valid suspension reason");
  }
};
var validateIsoCountryCode = exports.validateIsoCountryCode = function validateIsoCountryCode(countryCode) {
  validatePlainString(countryCode, 2, "country", 2, "^[A-Z][A-Z]$");
};
var validateApiKeyExpiration = exports.validateApiKeyExpiration = function validateApiKeyExpiration(expiration) {
  if (expiration) {
    validateDateIsoString(expiration);
    var date = (0, _moment["default"])(expiration);
    if (!date.isValid() || date.isAfter((0, _moment["default"])().add(1, "year"))) {
      throw new Error("Invalid expiration date");
    }
  }
};
var validateWalletType = exports.validateWalletType = function validateWalletType(type) {
  if (!["paypal"].includes(type)) {
    throw new Error("Invalid wallet type");
  }
};
var validateOrderType = exports.validateOrderType = function validateOrderType(type) {
  if (!["order", "subscription"].includes(type)) {
    throw new Error("Invalid order type");
  }
};
var validateEmailTemplate = exports.validateEmailTemplate = function validateEmailTemplate(template) {
  if (!emailTemplates.includes(template)) {
    throw new Error("Invalid email template");
  }
};